export const faviconPath = require('@ms/yammer-assets/dist/web/favicon.ico');
export const faviconDotPath = require('@ms/yammer-assets/dist/web/faviconDot.ico');
export const vivaEngageFaviconPath = require('@ms/yammer-assets/dist/web/ve/favicon.ico');
export const vivaEngageFaviconDotPath = require('@ms/yammer-assets/dist/web/ve/faviconDot.ico');
